module.exports = __webpack_public_path__ + "static/media/louise.5dec8b07.png";